export const flag = () => (
  <path
    d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1v12zm0 0v7"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
